import { ListContractsRequestContent, ListContractsResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to retrieve a list of user's contracts using the api-model
 * @param orgId Optional organization ID to filter contracts by organization
 * @returns Promise with list of contracts
 */
export const listContractsApi = async (orgId?: string): Promise<ListContractsResponseContent> => {
  // Use the utility function to handle auth, headers, and error handling
  const request = createApiRequest<ListContractsResponseContent>('post', '/listContracts');

  // Build request body with optional orgId
  const requestBody: ListContractsRequestContent = {};
  if (orgId) {
    requestBody.orgId = orgId;
  }

  return request(requestBody);
};